export default {
  typeLabel: {
    marginBottom: 36,
  },
};
